import { ScheduleProvider } from "Context/Schedule";
import { Schedule } from "./Schedule";

const SchedulePartner = () => {
  return (
    <ScheduleProvider>
      <Schedule />
    </ScheduleProvider>
  );
};

export default SchedulePartner;
